console.log("bundle is connected");

import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import dragScroll from 'dragscroll/dragscroll';
window.dragScroll = dragScroll;

let Swiper = require('swiper/swiper-bundle.js');
window.Swiper = Swiper
